import React, { FC, ReactNode } from 'react';
import styles from './index.style.module.css';

export interface QualityCardProps {
  /**
   * Content to display inside the card (fully customizable)
   */
  children: ReactNode;
  /**
   * Additional CSS classes for the card wrapper
   */
  className?: string;
}

/**
 * QualityCard - A molecule component that wraps Card atom
 * Provides a container for quality metrics, scores, and progress indicators
 * Content and layout are fully customizable via children prop
 */
const QualityCard: FC<QualityCardProps> = ({ children, className = '' }) => {
  return (
    <div className={`${styles.qualityCardWrapper} ${className}`}>
      {children}
    </div>
  );
};

QualityCard.displayName = 'QualityCard';

export default QualityCard;
